angular.module('lsnBase.deprecated.models')
  .factory('IHestiaUserRequestModel', ['LsnUserListRequestModelV1',
    function(LsnUserListRequestModelV1) {
      return LsnUserListRequestModelV1;
    }
  ]);